export default __webpack_public_path__ + "static/media/biofit-builder-series-RT.6069ee66.png";